<div class="one-time-items-container">
    <p-table #dt1 [value]="tenantContacts" class="items" [globalFilterFields]="['contactName', 'phones', 'emails', 'ar_type']" [loading]="loadingTenantContacts">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton label="Add Contact" class="p-button-outlined w-3" icon="pi pi-plus" (click)="showContactModal()"></button>
                <span class="p-input-icon-left ml-auto w-5">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')" placeholder="Search" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="col-qty">Num</th>
                <th>Contact Name</th>
                <th class="col-rate">Info</th>
                <th class="col-type">Effective Date</th>
                <th class="col-amount">Temination Date</th>
                <th class="col-amount" *ngIf="availableLineItemsData?.['wps_active']">Facility Code</th>
                <th class="col-amount">Key Card</th>
                <th class="col-amount">Rate</th>
                <th class="col-amount">AR Type</th>
                <th class="col-amount">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-i="rowIndex">
            <tr>
                <td>{{ i+1 }}</td>
                <td>{{ rowData.contactName }}<span style="font-size:x-small;font-style:italic;" *ngIf="i === 0"><br/>Billing Contact</span></td>
                <td>{{ rowData.phones }}  {{ rowData.extensions }}<br/>{{ rowData.emails }}<br/>{{ rowData.description }}</td>
                <td>{{ rowData.effectiveDates }}</td>
                <td>{{ rowData.terminationDates }}</td>
                <td *ngIf="availableLineItemsData?.['wps_active']">{{ rowData.facility_code }}</td>
                <td >{{ rowData.keycards }}</td>
                <td >{{ rowData.rate_desc }}</td>
                <td >{{ rowData.ar_type }}</td>
                <td>
                    
                    <button type="button" pButton icon="pi pi-pencil" iconPos="right" (click)="editContact(i)" class="p-button-rounded no-underline mr-2"></button>
                    <button type="button" pButton icon="pi pi-stop-circle" iconPos="right" (click)="holdKeycard(i, $event)" class="p-button-rounded no-underline mr-2"></button>
                    <button *ngIf="availableLineItemsData['parking_device'] == 'surepark'" type="button" pButton icon="pi pi-trash" iconPos="right" (click)="removeContact(i, $event, 'unlink')" class="p-button-rounded no-underline mr-2"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-confirmPopup></p-confirmPopup>
</div>

<p-dialog header="New Contact" [(visible)]="displayContactModal" [modal]="true" [style]="{ width: '60rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">

    <div class="col-12">
        <div class="grid">
            <div class="col-12 m-auto">
                <form [formGroup]="invoiceContactForm" autocomplete="off">
                    <div class="formgrid grid p-fluid mt-5">
                        <div class="grid col-12">
                            <div class="field col-3">
                                <span class="p-float-label mt-3">
                                    <input pInputText type="text" id="first-name" formControlName="contactFirstName"/>
                                    <label for="first-name">First Name</label>
                                </span>
                            </div>
                            <div class="field col-3">
                                <span class="p-float-label mt-3">
                                    <input pInputText type="text" id="last-name" formControlName="contactLastName"/>
                                    <label for="last-name">Last Name</label>
                                </span>
                            </div>
                            <div class="field col-6">
                                <span class="p-float-label mt-3">
                                    <input pInputText type="text" id="description" formControlName="description"/>
                                    <label for="description">Description</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid col-12">
                            <div class="field col-4">
                                <span class="p-float-label">
                                    <input pInputText type="text" id="phone" formControlName="phones"/>
                                    <label for="phone">Phone</label>
                                </span>
                            </div>
                            <div class="field col-2">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="extension" formControlName="extensions"/>
                                  <label for="extension">Extension</label>
                                </span>
                            </div>
                            <div class="field col-6">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="email" formControlName="emails"/>
                                  <label for="email">Email</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid col-12">
                            <div class="field col-3">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="make" formControlName="make"/>
                                  <label for="make">Make</label>
                                </span>
                            </div>
                            <div class="field col-3">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="model" formControlName="model"/>
                                  <label for="model">Model</label>
                                </span>
                            </div>
                            <div class="field col-3">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="year" formControlName="year"/>
                                  <label for="year">Year</label>
                                </span>
                            </div>
                            <div class="field col-3">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="color" formControlName="color"/>
                                  <label for="color">Color</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid col-12">
                            <div class="field col-6">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="plate" formControlName="plate"/>
                                  <label for="plate">License Plate</label>
                                </span>
                            </div>
                            <div class="field col-6">
                                <span class="p-float-label">
                                    <p-dropdown 
                                    id="state"
                                    [options]="states"
                                    [autoDisplayFirst]="false"
                                    formControlName="state"
                                    appendTo="body"></p-dropdown>
                                    <label for="state">State</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid col-12">
                            <div class="field col-3">
                                <span class="p-float-label">
                                  <p-calendar type="text" id="effectiveDates" formControlName="effectiveDates" [showIcon]="true" appendTo="body"></p-calendar>
                                  <label for="effectiveDates">Effective Date</label>
                                </span>
                            </div>
                            <div class="field col-3">
                                <span class="p-float-label">
                                  <p-calendar type="text" id="terminationDates" formControlName="terminationDates" [showIcon]="true" appendTo="body"></p-calendar>
                                  <label for="terminationDates">Termination Date</label>
                                </span>
                            </div>
                            <div class="field col-3" *ngIf="!availableLineItemsData?.['hangtag_location'] && availableLineItemsData?.['wps_active']">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="facility_code" formControlName="facility_code"/>
                                  <label for="facility_code">Facility Code</label>
                                </span>
                            </div>
                            <div class="field col-3" *ngIf="!availableLineItemsData?.['hangtag_location']">
                                <span class="p-float-label">
                                  <input pInputText type="text" id="keycard" formControlName="keycards"/>
                                  <label for="keycard">Keycard</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid col-12">
                            <div class="field col-6">
                                <span class="p-float-label mt-3">
                                    <p-dropdown 
                                    id="rate"
                                    [options]="availableLineItemsOptions"
                                    [autoDisplayFirst]="false"
                                    formControlName="rate_desc"
                                    appendTo="body"></p-dropdown>
                                  <label for="rate">Rate</label>
                                </span>
                            </div>
                            <div class="field col-3">
                                <span class="p-float-label mt-3">
                                  <p-dropdown
                                    id="ar-type"
                                    [options]="ARTypeOptions"
                                    [autoDisplayFirst]="false"
                                    optionLabel="name"
                                    optionValue="code"
                                    formControlName="ar_type"
                                    appendTo="body"
                                  >
                                  </p-dropdown>
                                  <label for="ar-type">AR Type</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid col-12" *ngIf="availableLineItemsData?.['wps_active'] && availableLineItemsData['parking_device'] != 'surepark'">
                            <div class="field col-6">
                                <span class="p-float-label mt-3">
                                    <p-dropdown 
                                    id="access_level"
                                    [options]="availableAccessLevelOptions"
                                    [autoDisplayFirst]="false"
                                    formControlName="access_level"
                                    appendTo="body"></p-dropdown>
                                  <label for="access_level">Access Level</label>
                                </span>
                            </div>
                            <div class="field col-6">
                                <span class="p-float-label mt-3">
                                    <p-dropdown 
                                    id="section"
                                    [options]="allowedSectionOptions"
                                    [autoDisplayFirst]="false"
                                    formControlName="section"
                                    appendTo="body"></p-dropdown>
                                  <label for="section">Sections</label>
                                </span>
                            </div>
                        </div>
                        <div class="grid col-12" *ngIf="availableLineItemsData?.['wps_active']">
                            <div class="field col-6">
                                <span class="p-float-label mt-3">
                                    <p-dropdown 
                                    id="keycard_action"
                                    [options]="availableKeycardActions"
                                    [(ngModel)]="selectedKeycardAction"
                                    (onChange)="keycardAction($event)"
                                    [autoDisplayFirst]="false"
                                    appendTo="body"
                                    placeholder="Keycard Actions"
                                    [disabled]="wpsSpinnerVisible"
                                    [ngModelOptions]="{standalone: true}">
                                </p-dropdown>
                                  <label for="keycard_action">Keycard Actions</label>
                                </span>
                            </div>
                            <div class="field col-6">
                                <span class="flex align-items-center gap-1 mt-3">
                                    <p-checkbox formControlName="keycard_active" [binary]="true" inputId="kc-active" (onChange)="toggleActive($event)" [disabled]="wpsSpinnerVisible"></p-checkbox>
                                    <label for="kc-active">KC Active <p-progressSpinner styleClass="w-1rem h-1rem" ariaLabel="loading" *ngIf="wpsSpinnerVisible"></p-progressSpinner></label>
                                </span>
                                {{ wpsStatusMsg }}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button *ngIf="editingContactIndex" class="uppercase" [disabled]="wpsSpinnerVisible" (click)="setAsBillingContact()" label="Set as billing contact"></p-button>
        <p-button class="uppercase" (click)="displayContactModal = false" label="Cancel"></p-button>
        <p-button class="uppercase" [disabled]="wpsSpinnerVisible" (click)="saveContact()" label="Save"></p-button>
    </ng-template>
</p-dialog>